<template>
  <nav class="breadcrumb" aria-label="breadcrumbs">
    <ul>
      <li>
        <nuxt-link :to="{ name: parent }">{{ parentText }}</nuxt-link>
      </li>
      <li v-for="crumb in crumbs" :key="crumb.path" :class="crumb.class">
        <nuxt-link :to="crumb.path" aria-current="page">
          {{ crumb.name }}
        </nuxt-link>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  props: {
    parent: {
      type: String,
      required: true
    },
    parentText: {
      type: String,
      required: true
    },
    idText: {
      type: String,
      default: ''
    }
  },
  computed: {
    crumbsTest: function () {
      const pathArray = this.$route.path.split('/')
      pathArray.shift()
      const len = pathArray.length
      const breadcrumbs = pathArray.reduce((breadcrumbArray, path, idx) => {
        console.log('ID')
        console.log(idx)
        console.log(len)
        console.log(this.$route.matched)

        if (len - 1 > idx) {
          console.log(this.$route.matched[idx].path)
          breadcrumbArray.push({
            path,
            to: breadcrumbArray[idx - 1]
              ? '/' + breadcrumbArray[idx - 1].path + '/' + path
              : '/' + path,
            text: this.$route.matched[idx].path || path
          })
        }
        return breadcrumbArray
      }, [])
      return breadcrumbs
    },
    crumbs() {
      const crumbs = []
      this.$route?.matched?.forEach((item, i, { length }) => {
        const crumb = {}
        crumb.path = item.path
        //  create a string for the translation to translate
        crumb.name = this.$i18n.t('route_' + (item.name || item.path))
        // is last item?
        if (i === length - 1) {
          // is param route? .../.../:id
          if (item.regex.keys.length > 0) {
            crumbs.push({
              path: item.path.replace(/\/:[^/:]*$/, ''),
              name: this.$t('route_' + item.name.replace(/-[^-]*$/, ''))
            })
            crumb.path = this.$route.path
            crumb.name = this.$t('route_' + this.$route.name, [
              crumb.path.match(/[^/]*$/)[0]
            ])
            //  for unique path names (paths with ID)
            if (this.$route.params.id && this.idText) {
              crumb.name = this.idText
            }
          }
          crumb.class = 'is-active'
        }
        crumbs.push(crumb)
      })

      return crumbs
    }
  }
}
</script>
